import styled from "styled-components";

export const ContentBox = styled.div`
  margin-top: 24px;
`;
